import React from 'react';
import { cn } from '@/lib/utils';

const SectionWrapper = ({ number, title, id, children, className, alt }) => (
  <section
    id={id}
    data-testid={`section-${id}`}
    className={cn(
      'py-10 px-4 sm:px-6 lg:px-8 section-enter scroll-mt-28',
      alt ? 'bg-slate-50 dark:bg-slate-900/40' : 'bg-white dark:bg-transparent',
      className
    )}
  >
    <div className="max-w-4xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        {number && (
          <div className="section-badge">{number}</div>
        )}
        <h2 className="text-xl sm:text-2xl font-semibold text-slate-900 dark:text-white font-heading">
          {title}
        </h2>
      </div>
      {children}
    </div>
  </section>
);

export default SectionWrapper;
